var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHrpmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 870.85 198.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#642778;}.cls-2{fill:#375ea9;}.cls-3{fill:#84cfef;}.cls-4{fill:#1d1d1d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.69,73.52h0l-126,126a36,36,0,1,0,50.92,50.91l64.54-64.54V99A35.9,35.9,0,0,1,181.69,73.52Z",
    transform: "translate(-45.15 -63.01)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.05,96.36C242,68.6,206.54,52.77,185.15,70.49a36,36,0,0,0-14,28.49v86.91l61.46-61.46A36,36,0,0,0,243.05,96.36Z",
    transform: "translate(-45.15 -63.01)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.15,138.07V99a35.88,35.88,0,0,1-10.54,25.45h0l-61.46,61.45V225a35.92,35.92,0,0,1,10.54-25.46Z",
    transform: "translate(-45.15 -63.01)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.69,73.52h0l-64.54,64.55-61.46,61.45A35.92,35.92,0,0,0,171.15,225h0a36,36,0,0,0,61.46,25.45l64.54-64.54V99A35.9,35.9,0,0,1,307.69,73.52Z",
    transform: "translate(-45.15 -63.01)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.61,124.44l-61.46,61.45V225a35.92,35.92,0,0,1,10.54-25.46h0l61.46-61.45V99a35.88,35.88,0,0,1-10.54,25.45Z",
    transform: "translate(-45.15 -63.01)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.05,96.36C368,68.6,332.54,52.77,311.15,70.49a36,36,0,0,0-14,28.49v86.91l61.46-61.46A36,36,0,0,0,369.05,96.36Z",
    transform: "translate(-45.15 -63.01)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.69,199.52A35.92,35.92,0,0,0,297.15,225h0a36,36,0,0,0,61.46,25.45h0A35.88,35.88,0,0,0,369.15,225h0V138.07l-61.46,61.45Z",
    transform: "translate(-45.15 -63.01)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "356.97 198.22 356.97 0.41 359.23 0.41 359.23 198.22 356.97 198.22 356.97 198.22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M469.14,126.72H447.85v24H436.24V92.64h11.61v22.89h21.29V92.64h11.61V150.7H469.14Z",
    transform: "translate(-45.15 -63.01)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M515.25,131.94H504.14V150.7H492.53V92.64h22.21c13.72,0,20.2,5.55,20.2,19.27,0,8.58-3.2,13.3-8.42,16.58l8.16,22.21H522Zm-.51-28.28h-10.6v17.25h10.77c5.81,0,8.16-3.61,8.16-8.83C523.07,106.53,520.3,103.66,514.74,103.66Z",
    transform: "translate(-45.15 -63.01)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M441.39,203.9v19.74h-5V166.79h20.64c12.15,0,17.61,5.63,17.61,17.78s-5.46,19.33-17.61,19.33Zm15.66-4.81c8.8,0,12.47-5.55,12.47-14.52s-3.67-13-12.47-13H441.39v27.57Z",
    transform: "translate(-45.15 -63.01)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M515.28,202.68c0,14.6-3.35,21.77-17,21.77S481.1,218,481.1,202.6c0-14.44,4.57-20.47,17.21-20.47C510.14,182.13,515.28,188.41,515.28,202.68Zm-5.06,0c0-11.66-3.59-16.15-11.91-16.15-9.38,0-12.23,3.91-12.23,16.07,0,12.39,1.71,17.45,12.23,17.45S510.22,214.34,510.22,202.68Z",
    transform: "translate(-45.15 -63.01)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M525.55,182.86l9.05,36.37h1.14l10.61-35.56h5.22l10.52,35.56h1.22l9.05-36.37h5l-10.28,40.78H558.5L548.87,190l-9.62,33.6h-8.48l-10.2-40.78Z",
    transform: "translate(-45.15 -63.01)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M613.87,219.23l.17,4.08s-9.22,1.14-15.58,1.14c-12.15-.08-15.82-7.42-15.82-21,0-15.74,6.85-21.28,16.8-21.28,10.52,0,16.07,5.54,16.07,19.24l-.17,3.92H587.61c0,9.62,2.78,14.68,11.34,14.68C604.9,220,613.87,219.23,613.87,219.23Zm-3.26-18c0-10.77-3.5-14.76-11.17-14.76-7.42,0-11.83,4.16-11.83,14.76Z",
    transform: "translate(-45.15 -63.01)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M625.45,182.86h4.89v5.79A39.52,39.52,0,0,1,645.27,182v5a49.6,49.6,0,0,0-14.93,6.2v30.42h-4.89Z",
    transform: "translate(-45.15 -63.01)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M674.6,167.24h9.14l17.78,49.5,17.86-49.5h9v56.84h-5V172.86h-1.15l-17.94,49.35H698.5l-17.78-49.35h-1.14v51.22h-5Z",
    transform: "translate(-45.15 -63.01)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M769.37,219.68l.16,4.08s-9.22,1.14-15.58,1.14c-12.15-.08-15.82-7.42-15.82-21,0-15.74,6.85-21.29,16.8-21.29,10.52,0,16.07,5.55,16.07,19.25l-.16,3.91H743.11c0,9.63,2.77,14.68,11.33,14.68C760.4,220.41,769.37,219.68,769.37,219.68Zm-3.26-18c0-10.77-3.51-14.77-11.18-14.77-7.42,0-11.82,4.16-11.82,14.77Z",
    transform: "translate(-45.15 -63.01)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M781,224.08V183.3h4.89v2.94s7-3.67,13.21-3.67c11.18,0,13.62,5.14,13.62,20.31v21.2h-4.81V203c0-11.91-1.3-15.9-9.38-15.9-6.11,0-12.64,3.42-12.64,3.42v33.6Z",
    transform: "translate(-45.15 -63.01)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M831.67,187.79v19.82c0,10.19.66,12.8,6.45,12.8,2.28,0,7.58-.57,7.58-.57l.25,4.33a76.61,76.61,0,0,1-8.24.81c-8,0-10.93-3-10.93-14.76V187.79h-6V183.3h6V170.5h4.89v12.8h13.62v4.49Z",
    transform: "translate(-45.15 -63.01)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M885.91,203.12c0,14.6-3.35,21.78-17,21.78s-17.21-6.44-17.21-21.86c0-14.43,4.57-20.47,17.21-20.47C880.77,182.57,885.91,188.85,885.91,203.12Zm-5.06,0c0-11.66-3.59-16.15-11.91-16.15-9.38,0-12.23,3.92-12.23,16.07,0,12.4,1.71,17.45,12.23,17.45S880.85,214.79,880.85,203.12Z",
    transform: "translate(-45.15 -63.01)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M896.18,183.3h4.89v5.8A39.52,39.52,0,0,1,916,182.49v5a49.6,49.6,0,0,0-14.93,6.2v30.42h-4.89Z",
    transform: "translate(-45.15 -63.01)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrpmLogo);
export default __webpack_public_path__ + "static/media/hrpm-logo.2b34a2372a782096510609b69dc55405.svg";
export { ForwardRef as ReactComponent };